<div>
    <header class="mat-elevation-z3">
        <mat-toolbar class="p-0" color="primary">
            <nav class="navbar-header main-view w-100">
                <div class="header-right-32 d-flex justify-content-center p-0">
                    <div>
                        <img class="app-img-logo" alt="App Logo" src="assets/img/logo-hartmann.svg">
                    </div>
                    <div class="cursor">
                        <img alt="Health Logo" routerLink="/dashboard" class="health-logo" src="assets/img/svg/health-plus.svg">
                    </div>
                </div>
                <div class="flex-spacer"></div>
                <a class="icon-apps" id="removeCls1" (click)="onChangeApp()" mat-button matTooltip="{{'AppManager'|translate}}"
                     container="body">
                    <mat-icon>apps</mat-icon>
                </a>
                <a class="border-right-div pr-2 mr-2"></a>
                <a *ngIf="((hasMultipleCountries > 1) || (optionsLang.length > 1))" [ngClass]="{'lang-selection-cls':showClass}" class="icon-lang">
                    <mat-select #mySelect panelClass="myPanelClass" class="drop-container p-0" [(ngModel)]="initialLanguage">
                        <mat-select-trigger>
                            <span class="img-lang-container mr-1">
                                <mat-icon>language</mat-icon>
                            </span>
                            <span>{{getLangName(initialLanguage)}}</span>
                        </mat-select-trigger>
                        <label class="radio-group-label">{{'SelectLanguage' | translate}}</label>
                        <mat-radio-group name='Lang' [(ngModel)]="initialLanguageRadio">
                            <mat-option *ngFor="let option of optionsLang" [value]="option.description.toLowerCase()" class="p-0 min-h-53">
                                <div>
                                    <mat-radio-button (change)="selectLanguage($event.value)" [value]="option.description.toLowerCase()" style="display: block; padding: 0px 12px 0px 12px;">
                                        {{translate.instant(option.name)}}
                                    </mat-radio-button>
                                </div>
                            </mat-option>
                        </mat-radio-group>
                        <div class="mt-1">
                            <mat-divider></mat-divider>
                            <label class="radio-group-label">{{'Country' | translate}}</label>
                            <div class="change_country pl-2">
                                <div class="row pl-2 vert-middle">
                                    <span class="img-lang-container mr-1">
                                        <div class="flag-image" [ngStyle]="{'background': 'url(https://storagedhhpsit.blob.core.windows.net/platformassets/countryflags/' + userCountry.toLowerCase() +'.svg)', 'background-size': 'cover', 'background-position': 'center', 'background-repeat': 'no-repeat'}"
                                            ></div>
                                    </span>
                                    <span class="pl-2 country_name">
                                        {{getCountryName(userCountry)}}
                                    </span>
                                </div>
                                <div *ngIf="hasMultipleCountries > 1" class="row pt-1 pb-0 change_country text-center display-block" (click)="changeCountry()">
                                    <span class="display-inline">
                                        {{'changeLanguageRegion' | translate}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </mat-select>
                </a>

                <a class="icon-notify" id="removeCls3" (click)="onChangeAlert()" mat-button matTooltip="{{'Notification'|translate}}"
                     container="body">
                    <mat-icon *ngIf="nCount>0" [matBadge]="nCount" matBadgePosition="after" matBadgeOverlap="false" matBadgeColor="warn">notification_important</mat-icon>
                    <mat-icon *ngIf="nCount==0">notification_important</mat-icon>
                </a>
                <a class="icon-search" id="removeCls4" (click)="onShowHelp()" mat-button matTooltip="{{'Help'|translate}}"
                     container="body">
                    <mat-icon>help_outline</mat-icon>
                </a>
                <a class="icon-search" (click)="onShowContact()" mat-button matTooltip="{{'Contact'|translate}}" 
                    container="body">
                    <img style="width:18px;height:21px;" src="assets/img/AU-img/support-nav.svg" />
                </a>
                <a class="border-right-div pr-2 mr-2"></a>
                <a class="pl-3 icon-profile" id="removeCls5" (click)="onChangeProfile()" mat-button>
                    <mat-icon style="font-family: OpenSans-Regular;font-weight: bold;">
                        <div class="text-profile-menu d-flex justify-content-center ">
                            <p class="d-flex align-items-center">{{profileName}}</p>
                        </div>
                    </mat-icon>
                    <span class="user-name">{{fullName}}</span>
                </a>
            </nav>
        </mat-toolbar>
    </header>
</div>